import { ButtonIcon, styled, Modal, Paragraph, TrashIcon, ListItem } from 'canoe';
import React, { useCallback, useState } from 'react';

import { WebFontResource } from '../types';

interface Props {
  font: WebFontResource;
  onDelete: (id: string) => void;
  onSelect: (font: WebFontResource) => void;
}

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  & > li {
    flex: 1;
  }
`;

export const FontItem = React.memo(({ font, onSelect, onDelete, ...props }: Props) => {
  const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);

  const closeModal = useCallback(() => {
    setConfirmDeleteModal(false);
  }, []);

  const openModal = useCallback(() => {
    setConfirmDeleteModal(true);
  }, []);
  const onConfirmDelete = useCallback(() => {
    onDelete(font.id);
    closeModal();
  }, [font.id, closeModal, onDelete]);
  return (
    <>
      {confirmDeleteModal && (
        <Modal closeOnClickOutside onClose={closeModal} severity="Danger">
          <Modal.Header title="Delete custom Font?" />
          <Modal.Body>
            <Paragraph>
              {`You are about to delete: “${font.family}” this will no longer be available. Are you sure you want to continue?`}
            </Paragraph>
          </Modal.Body>
          <Modal.Footer
            primaryAction={{
              variant: 'danger',
              onClick: onConfirmDelete,
              children: 'Delete',
            }}
          />
        </Modal>
      )}

      <Row>
        <ListItem {...props} mr="xxs" onClick={() => onSelect(font)}>
          {font.family}
        </ListItem>
        <ButtonIcon color="danger" onClick={openModal} icon={TrashIcon} />
      </Row>
    </>
  );
});
